// Is this click target (or an ancestor) a top-level navigation control — the
// sidebar / dock item or a phone tab-bar button? Used by the quiet update to
// decide at the TAP, before the new tab starts loading.
const TOP_NAV_SELECTOR = '[data-testid^="nav-item-"], [data-cvx-bottom-tab] button';

/** The tab key of a sidebar/dock item (`nav-item-<key>`), or null when unknown. */
export function topNavTargetKey(el) {
  try {
    const item = el && typeof el.closest === 'function' ? el.closest('[data-testid^="nav-item-"]') : null;
    return item ? item.getAttribute('data-testid').slice('nav-item-'.length) || null : null;
  } catch (_) {
    return null;
  }
}

export function isTopNavClickTarget(el) {
  try {
    return !!(el && typeof el.closest === 'function' && el.closest(TOP_NAV_SELECTOR));
  } catch (_) {
    return false;
  }
}
